// @ts-nocheck
import React from "react";

const DeferredMount = ({
  children,
  timeoutMs = 1200,
  interactionEvents = ["pointerdown", "touchstart", "keydown", "scroll"],
}) => {
  const [shouldRender, setShouldRender] = React.useState(false);

  React.useEffect(() => {
    if (shouldRender || typeof window === "undefined") {
      return undefined;
    }

    let cancelled = false;
    let timeoutId = 0;
    let idleId = 0;

    const activate = () => {
      if (cancelled) {
        return;
      }

      setShouldRender(true);
    };

    const clearListeners = () => {
      interactionEvents.forEach((eventName) => {
        window.removeEventListener(eventName, activate);
      });
    };

    interactionEvents.forEach((eventName) => {
      window.addEventListener(eventName, activate, { passive: true, once: true });
    });

    if (typeof window.requestIdleCallback === "function") {
      idleId = window.requestIdleCallback(activate, { timeout: timeoutMs });
    } else {
      timeoutId = window.setTimeout(activate, timeoutMs);
    }

    return () => {
      cancelled = true;
      clearListeners();
      if (idleId && typeof window.cancelIdleCallback === "function") {
        window.cancelIdleCallback(idleId);
      }
      if (timeoutId) {
        window.clearTimeout(timeoutId);
      }
    };
  }, [interactionEvents, shouldRender, timeoutMs]);

  return shouldRender ? children : null;
};

export default DeferredMount;
